import React, { useContext } from "react"
import { StaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { Link } from "gatsby"

import { Dropdown } from "../../atoms/dropdown"
import SiteContext from "../../../context/SiteContext"

import find from "lodash.find"

const Links = styled.div`
  position: relative;
  > div {
    display: inline-block;
    margin: 0 0.5rem;
    position: relative;
    padding: 1rem 0;
    > div {
      opacity: 0;
      transition: opacity 175ms ease-in-out;
      pointer-events: none;
    }
    > a {
      position: relative;
      z-index: 4;
    }
  }
  > div:hover {
    > div {
      opacity: 1;
      pointer-events: all;
    }
  }
  a {
    text-decoration: none;
    color: #000;
    cursor: pointer;
  }
`

export const Navlinks = () => {
  const context = useContext(SiteContext)
  return (
    <StaticQuery
      query={graphql`
        query {
          allContentfulMainNavigation {
            edges {
              node {
                title
                navigationGroups {
                  pages {
                    id
                    slug
                    title
                  }
                  slug
                  title
                }
              }
            }
          }
        }
      `}
      render={data => (
        <Links>
          {find(data.allContentfulMainNavigation.edges, function(edge) {
            return context.trade === true || context.trade === "true"
              ? edge.node.title === "Trade Links"
              : edge.node.title === "Public Links"
          }).node.navigationGroups.map((link, i) => (
            <div key={i}>
              {link.slug ? (
                /^(http|https):/.test(link.slug) === true ? (
                  <a href={link.slug} target="_blank">
                    {link.title}
                  </a>
                ) : (
                  <Link to={link.slug}>{link.title}</Link>
                )
              ) : (
                <a>{link.title}</a>
              )}
              {link.pages ? <Dropdown data={link.pages} /> : ""}
            </div>
          ))}
        </Links>
      )}
    />
  )
}
